import * as React from "react"

export const Header = ({ onThemeChange }: { onThemeChange(): void }) => (
  <div className="Header">
    <div className="Header__title">kavehsajjadi.com &gt;&gt; blog</div>
    <ThemeButton onClick={onThemeChange} />
  </div>
)

const ThemeButton = ({ onClick }: { onClick(): void }) => (
  <button className="ThemeButton" onClick={onClick} type="button">
    Toggle Dark Move
  </button>
)
